import { render, staticRenderFns } from "./ProfileHistoryWithEmployee.vue?vue&type=template&id=9fd2b05e&"
import script from "./ProfileHistoryWithEmployee.vue?vue&type=script&lang=js&"
export * from "./ProfileHistoryWithEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports